import { Link } from "react-router-dom";
import Section from "../Section";

function VerifyDetails() {
  return (
    <Section
      title="Verify Details"
      text="How would you like to verify your personal details?"
    >
      <Link
        className="btn w-100 btn-outline-primary mb-3"
        to="/bvn-verification-start"
        replace
      >
        BVN Verification
      </Link>
      <Link
        className="btn w-100 btn-outline-primary"
        to="/nin-verification-start"
        replace
      >
        NIN Verification
      </Link>
    </Section>
  );
}
export default VerifyDetails;